import type { NovelItem } from '@app/_proto/Protos/novels';
import DarkBooksLayout from '@app/domains/common/containers/DarkBooksLayout';
import { HomeCollectionSlots } from '@app/domains/home/analytics/posthog/constants';
import HomeCollection from '@app/domains/home/components/HomeCollection';
import HomeSneakPeekContent from '@app/domains/home/components/HomeSneakPeekContent';
import HomeSwiper from '@app/domains/home/components/HomeSwiper';
import { useHomePopularSlidesPerView } from '@app/domains/home/containers/HomePopularNovels';
import useSneakPeeks from '@app/domains/home/hooks/useSneakPeeks';
import {
    HOME_SWIPER_SLIDE_SIZE_PER_VIEW_STYLE,
    HOME_SWIPER_WITH_TOP_SHADOW_LAYOUT_STYLE,
} from '@app/domains/home/styles';
import { breakpoints } from '@app/utils/breakpoints';
import { useMediaQuery } from '@mui/material';
import { useInView } from 'react-intersection-observer';

export default function HomeSneakPeekNovelsN() {
    const { ref, inView } = useInView({
        triggerOnce: true,
    });

    const { data: contents = Array<undefined>(10).fill(undefined), isSuccess } = useSneakPeeks({ enabled: inView });
    const isLoading = !isSuccess;

    const slidesPerView = useHomePopularSlidesPerView();
    const isDownLg = useMediaQuery(breakpoints.downLg, {
        noSsr: true,
    });

    return (
        <div ref={ref}>
            <HomeCollection data-posthog-params={JSON.stringify({ collectionSlot: HomeCollectionSlots.SneakPeek })}>
                <DarkBooksLayout>
                    <DarkBooksLayout.TitleSection className="flex flex-col justify-end">
                        <img className="w-140 md:w-176" src="/images/champion-logo@3x.png" alt="champion-logo" />
                        <HomeCollection.Title
                            title="Sneak Peeks"
                            classes={{ heading: 'font-set-b24 pb-4 text-white md:font-set-b28' }}
                        />
                        <h4 className="font-set-m14 pb-12 text-gray-400 md:font-set-m16 md:pb-6">
                            Become a Champion and get a preview of upcoming series!
                        </h4>
                    </DarkBooksLayout.TitleSection>
                    <DarkBooksLayout.ContentSection>
                        <div className="pb-20 md:pb-12">
                            <HomeSwiper
                                slidesPerView={slidesPerView}
                                slidesPerGroup={isDownLg ? 1 : 7}
                                className={HOME_SWIPER_WITH_TOP_SHADOW_LAYOUT_STYLE}
                                dark={true}
                                isLoading={isLoading}
                            >
                                {contents?.map((content: NovelItem | undefined, idx) => (
                                    <HomeSwiper.Slide
                                        key={idx}
                                        className={HOME_SWIPER_SLIDE_SIZE_PER_VIEW_STYLE}
                                        data-posthog-params={JSON.stringify({ itemSlot: idx })}
                                    >
                                        <HomeSneakPeekContent content={content} isLoading={isLoading} />
                                    </HomeSwiper.Slide>
                                ))}
                            </HomeSwiper>
                        </div>
                    </DarkBooksLayout.ContentSection>
                </DarkBooksLayout>
            </HomeCollection>
        </div>
    );
}
